import type { Workspace } from '@/entities/workspace';
import { can, PERMISSIONS } from '@/shared/lib/permissions';

/** May the viewer restyle the workspace header (the same right as changing its settings)? */
export const canStyleWorkspace = (workspace: Workspace): boolean =>
  can(workspace.permissions, PERMISSIONS.workspaceUpdateSettings);
